import { computed } from 'vue';
import { useStore, useStoreGetters } from 'dashboard/composables/store';
import { useAdmin } from 'dashboard/composables/useAdmin';

/**
 * Infraestrutura do menu "OCULTAR": esconde itens de UI especificos sem
 * desativar a funcionalidade por tras. A lista de itens ocultos fica salva
 * em Account.settings.odtravel_hidden_ui (mesmo campo jsonb ja usado pra
 * outras preferencias nativas), sem precisar de coluna/migration nova. A
 * configuracao pode ser escrita por fora (SQL direto ou uma telinha propria
 * fora do Chatwoot), sem exigir rebuild da imagem pra trocar o que esta
 * oculto: so essa logica condicional aqui precisa de build, uma vez.
 *
 * Regra do Build 6: Administrator sempre ve/edita tudo, independente da
 * configuracao. So Agent (nao-admin) e afetado por qualquer secao ocultada
 * aqui (sidebar, labels, customAttributes, actionButtons).
 *
 * Formato esperado em settings.odtravel_hidden_ui:
 * { sidebar: ['Calls', 'Campaigns'], actionButtons: ['iaraToggle'] }
 */
export function useHiddenUi() {
  const store = useStore();
  const getters = useStoreGetters();
  const { isAdmin } = useAdmin();
  const accountId = computed(() => getters.getCurrentAccountId.value);
  const account = computed(() =>
    store.getters['accounts/getAccount'](accountId.value)
  );

  const hiddenConfig = computed(
    () => account.value?.settings?.odtravel_hidden_ui ?? {}
  );

  const isHidden = (section, key) => {
    if (isAdmin.value) return false;
    return (hiddenConfig.value[section] ?? []).includes(key);
  };

  return { isHidden };
}
